import { AtendimentoProvider } from '$providers/atendimento';
import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';
import { AtendimentoViewPage } from '../atendimento-view/atendimento-view';

@Component({
  selector: 'page-atendimento-list',
  templateUrl: 'atendimento-list.html',
})
export class AtendimentoListPage {

  dados: Array<any>;
  constructor(public navCtrl: NavController, private provider: AtendimentoProvider) {
    this.dados = [];
  }

  ionViewDidLoad() {
    this.provider.loadItems().subscribe(
      (dados) => {
        this.dados = dados;
      },
      (err) => console.error(err)
    )
  }

  abrir(atendimento) {
    this.provider.get(atendimento.id).subscribe(
      (dados) => this.navCtrl.push(AtendimentoViewPage, { atendimento: dados }),
      (err) => console.error(err));
  }
}



// WEBPACK FOOTER //
// ./src/pages/atendimento/atendimento-list/atendimento-list.ts